export function fullDomain(domain: string) {
  return `${window.location.protocol}//${domain}.${
    import.meta.env.VITE_BACKEND_URL ?? window.location.host
  }`;
}

export function randString(length: number) {
  return Array.from(
    { length: length },
    () => "abcdefghijklmnopqrstuvwxyz0123456789"[Math.floor(Math.random() * 36)]
  ).join("");
}
